// extracted by mini-css-extract-plugin
module.exports = {"loader":"WKA0s0xKGd5Og7OnXxBjv"};